import type { Dictionary, Translation } from '@/i18n/types';

const ro = {
  errorTitle: 'Autentificare eșuată — AKIS',
  blockedHeading: 'Acces dezactivat',
  blockedBody:
    'Contul dumneavoastră nu mai are acces la SI AKIS. Pentru reactivare, contactați administratorul platformei.',
  blockedCta: 'Contactați-ne',
  failedHeading: 'Autentificare anulată sau eșuată',
  failedBody:
    'Nu am putut finaliza autentificarea prin M-Pass. Puteți încerca din nou sau reveni la pagina principală.',
  failedCta: 'Încearcă din nou',
  home: 'Pagina principală',

  mockTitle: 'Autentificare M-Pass (mediu de dezvoltare) — AKIS',
  mockHeading: 'Autentificare M-Pass',
  mockSubtitle: 'Serviciul guvernamental de autentificare — Republica Moldova',
  mockNoteBefore: 'Profilul',
  mockNoteAfter:
    'este activ; în producție această pagină este înlocuită de M-Pass real (SAML 2.0).',
  mockName: 'Nume complet',
  mockIdnp: 'IDNP',
  mockIdnpHint: '13 cifre, conform buletinului de identitate.',
  mockRole: 'Rol suplimentar (opțional)',
  mockRoleNone: '— fără (utilizator autentificat) —',
  mockReplaceRoles: 'Doar rolul selectat (înlocuiește rolurile acumulate pe acest IDNP)',
  mockSubmit: 'Autentifică-te prin M-Pass',
  mockDisclaimer:
    'Datele introduse sunt folosite doar pentru simularea sesiunii în mediul de dezvoltare.',
  mockErrorIdnp: 'IDNP invalid — trebuie să conțină exact 13 cifre.',
  mockRolesUnavailable: 'Lista de roluri nu a putut fi încărcată.',
} as const;

const en = {
  errorTitle: 'Sign-in failed — AKIS',
  blockedHeading: 'Access disabled',
  blockedBody:
    'Your account no longer has access to AKIS. To have it reactivated, contact the platform administrator.',
  blockedCta: 'Contact us',
  failedHeading: 'Sign-in cancelled or failed',
  failedBody:
    'We could not complete sign-in through M-Pass. You can try again or return to the home page.',
  failedCta: 'Try again',
  home: 'Home page',

  mockTitle: 'M-Pass sign-in (development environment) — AKIS',
  mockHeading: 'M-Pass sign-in',
  mockSubtitle: 'Government authentication service — Republic of Moldova',
  mockNoteBefore: 'Profile',
  mockNoteAfter: 'is active; in production this page is replaced by the real M-Pass (SAML 2.0).',
  mockName: 'Full name',
  mockIdnp: 'IDNP',
  mockIdnpHint: '13 digits, as printed on the identity card.',
  mockRole: 'Additional role (optional)',
  mockRoleNone: '— none (authenticated user) —',
  mockReplaceRoles: 'Only the selected role (replaces roles accumulated on this IDNP)',
  mockSubmit: 'Sign in with M-Pass',
  mockDisclaimer:
    'The details entered are used only to simulate a session in the development environment.',
  mockErrorIdnp: 'Invalid IDNP — it must contain exactly 13 digits.',
  mockRolesUnavailable: 'The role list could not be loaded.',
} satisfies Translation<keyof typeof ro>;

export const auth = { ro, en } satisfies Dictionary;

export type AuthKey = keyof typeof ro;
